import template from './termination_reason.html';
import tr from '../../lib/default-translator.js';

class AdminTerminationReasonViewModel
{
	constructor(page)
	{
		this.page = page;
	}

	show_contract_type_help()
	{
		//Grape.dialog.open('ContractsHelp', { employee_id: this.page.bindings.id });
	}
}

class AdminTerminationReasonPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AdminTerminationReasonViewModel(this);
		document.title = tr('Manage Termination Reasons');
		window.current_page_title(tr('Add/Edit Termination Reasons'));
	}
}

export default {
	route: '[/]admin/termination_reason',
	page_class: AdminTerminationReasonPage,
	template: template,
	template_filename: 'translation/termination_reason'
};
